export const emitNotSupportedError = (observer) => {
    observer.error(new Error('The required browser API seems to be not supported.'));
    return () => { }; // tslint:disable-line:no-empty
};
//# sourceMappingURL=emit-not-supported-error.js.map